import React from 'react';
import { observer } from "mobx-react";
import uniqueId from 'lodash/uniqueId';
import { Icon } from 'components/Icon';
import { AovProgressBarIcon } from 'components/Svg';
import MenuItem from '../Menu/MenuItem';
import AdminMenuGroup from '../Menu/AdminMenuGroup';
import EcommerceMenu from '../Menu/EcommerceMenu';
import consoleStore from 'stores/Console/ConsoleStore';
import constants from 'Constants';
import * as auth from 'Auth';
import * as paths from 'Paths';
import * as utils from 'Utils';
import './styles.scss';




@observer
class OverviewMenu extends React.Component {
  constructor (props) {
    super(props);
    this.overviewUrl = paths.getPathAovProgressBarOverview();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.AOV_PROGRESS_BAR_MENU.OVERVIEW);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.AOV_PROGRESS_BAR_SIDEBAR.OVERVIEW;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.AOV_PROGRESS_BAR_MENU.OVERVIEW}
        menuName="Overview"
        icon="slider"
        href={this.overviewUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}



@observer
class ConnectionsMenu extends React.Component {
  constructor (props) {
    super(props);
    this.connectionsUrl = paths.getPathAovProgressBarConnections();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.AOV_PROGRESS_BAR_MENU.CONNECTIONS);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.AOV_PROGRESS_BAR_SIDEBAR.CONNECTIONS;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.AOV_PROGRESS_BAR_MENU.CONNECTIONS}
        menuName="Connections"
        icon="shape-circle"
        href={this.connectionsUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}


@observer
class AovProgressBarSidebar extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      activeMenu: "",
    };
  }

  componentDidMount() {
    auth.setCurrentProduct(constants.PRODUCT_AOV_PROGRESS_BAR);
  }

  updateActiveMenu = (activeMenu) => {
    if (this.state.activeMenu === activeMenu) {
      this.setState({activeMenu: ""});
      return;
    }

    this.setState({activeMenu: activeMenu});
  };

  render() {
    return (
      <div className="sidebar sidebar-aovprogressbar">
        <div className="sidebar-head">
          <div className="head-icon"><AovProgressBarIcon /></div>
          <div className="head-title">AOV Progress Bar</div>
        </div>

        <div className="menu-items">
          <div className="menu-group">
            <OverviewMenu
              isActive={this.state.activeMenu === constants.AOV_PROGRESS_BAR_MENU.OVERVIEW}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <EcommerceMenu
              theme={constants.PRODUCT_AOV_PROGRESS_BAR}
              isActive={this.state.activeMenu === constants.AOV_PROGRESS_BAR_MENU.ECOMMERCE}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <ConnectionsMenu
              isActive={this.state.activeMenu === constants.AOV_PROGRESS_BAR_MENU.CONNECTIONS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />
          </div>

          <AdminMenuGroup
            activeMenu={this.state.activeMenu}
            updateActiveMenu={this.updateActiveMenu}
            product={constants.PRODUCT_AOV_PROGRESS_BAR}
            {...this.props}
          />
        </div>
      </div>
    );
  }
}



export { AovProgressBarSidebar };

